__turbopack_context__.v({
  "items": "side-nav-module-scss-module__tIRb9a__items",
  "labelIn": "side-nav-module-scss-module__tIRb9a__labelIn",
  "sideNav": "side-nav-module-scss-module__tIRb9a__sideNav",
  "sideNavExpanded": "side-nav-module-scss-module__tIRb9a__sideNavExpanded",
});
